
<template>
    <div>
        <Header></Header>
        <Ground :id="pageData.type"></Ground>
        <ALink :nav='pageData.tab'></ALink>
        <template v-for='item in pageData.obj'>
            <a :name="item.name"></a>
            <template v-if='item.type==1'>
                <YWCJ :data='item.data' :name='item.name'></YWCJ>  
            </template>
            <template v-else-if='item.type==2'>
                <DXAL :data='item.data' :name='item.name'></DXAL>  
            </template>
            <template v-else-if='item.type==3'>
                <CGKH :data='item.data' :name='item.name'></CGKH>  
            </template>
            <template v-else-if='item.type==4'>
                <FLAI :data='item.data' :name='item.name'></FLAI>  
            </template>
            <template v-else-if='item.type==5'>
                <CPGS :data='item.data' :name='item.name'></CPGS>  
            </template>
            <template v-else-if='item.type==6'>
                <CPYS :data='item.data' :name='item.name'></CPYS>  
            </template>
            <template v-else-if='item.type==7'>
                <CPJZ :data='item.data' :name='item.name'></CPJZ>  
            </template>
            <template v-else-if='item.type==8'>
                <YYCJ :data='item.data' :name='item.name'></YYCJ>  
            </template>
            <template v-else-if='item.type==9'>
                <CPJS :data='item.data' :name='item.name'></CPJS>  
            </template>
        </template>
        <div class="form-box">
            <Form></Form>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Ground from '@/components/Ground.vue'
import Form from '@/components/Form.vue'
import Footer from '@/components/Footer.vue'

import ALink from '@/components/aLink.vue'
import YWCJ from '@/components/blcok/ywcj.vue'
import DXAL from '@/components/blcok/dxal.vue'
import CGKH from '@/components/blcok/cgkh.vue'
import FLAI from '@/components/blcok/flai.vue'
import CPGS from '@/components/blcok/cpgs.vue'
import CPYS from '@/components/blcok/cpys.vue'
import CPJZ from '@/components/blcok/cpjz.vue'
import YYCJ from '@/components/blcok/yycj.vue'
import CPJS from '@/components/blcok/cpjs.vue'
export default {
    name: 'Serve',
    components: {
      Header,
      Ground,
      Form,
      Footer,

      ALink,
      YWCJ,
      DXAL,
      CGKH,
      FLAI,
      CPGS,
      CPYS,
      CPJZ,
      YYCJ,
      CPJS
    },
    data() {
        return {
            schemeData: window.schemeData,
        }
    },
    computed: {
        pageData: function(){
            window.scrollTo(0, 0);
            return this.schemeData[this.$route.query.name]||{}
        }
    },
    mounted() {},
    methods: {

    }
}
</script>
<style scoped>
.form-box{
    padding: 35px 0 65px;
    background: url(../assets/images/panel_item7_bg.png) no-repeat 0 0;
}
</style>